module.exports = __webpack_public_path__ + "static/img/qyjj-ban.b4acbe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qyjj-ban.jpg
// module id = LMHE
// module chunks = 1